import { z as t } from "zod";
const r = t.object({
  firstName: t.string().optional(),
  lastName: t.string().optional(),
  street: t.string().optional(),
  street2: t.string().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  country: t.string(),
  state: t.string().optional(),
  phoneNumber: t.string().optional()
}), o = t.record(
  t.string(),
  t.union([t.string(), t.boolean(), t.array(t.string())])
), i = t.object({
  id: t.string(),
  email: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  addresses: r.array(),
  attributes: o.optional()
});
export {
  r as customerAddressSchema,
  o as customerAttributesSchema,
  i as customerSchema
};
